import React from 'react';

 import { Container, Title, Text } from './styles';

 function BlockMigration() {
   return (
     <Container>
       <Text>
         Não foi possível continuar com o cadastro no momento.
         Seu condomínio está em processo de atualização em nossos sistemas.
         Tente novamente mais tarde ou em caso de urgência do religue do gás entre em contato com a nossa central de atendimento.
       </Text>
     </Container>
   )
 }

	 export default BlockMigration;
